import { API_ENDPOINTS } from "@/constants/api";
import { axiosApiInstance } from "@/libs/axios";
import { AvailableRoles } from "@/types";

export const selectAccount = async (account_type: AvailableRoles) => {
  return axiosApiInstance.patch<{ code: "selected_tutor_account" }>(
    API_ENDPOINTS.AUTH.ONBOARDING.ACCOUNT_TYPE,
    { account_type },
  );
};

export const sendPersonalData = async ({
  firstName,
  lastName,
  birthDate,
}: {
  firstName: string;
  lastName: string;
  birthDate: string;
}) => {
  return axiosApiInstance.patch<{
    code: "personal_data_updated";
  }>(API_ENDPOINTS.AUTH.ONBOARDING.PERSONAL_DATA, {
    first_name: firstName,
    last_name: lastName,
    date_of_birth: birthDate,
  });
};

export const sendCommunicationData = async ({
  phoneNumber,
  phoneNumberCountry,
  secondaryEmail,
}: {
  phoneNumber: string;
  phoneNumberCountry: string;
  secondaryEmail?: string;
}) => {
  return axiosApiInstance.patch(API_ENDPOINTS.AUTH.ONBOARDING.COMMUNICATION_DATA, {
    phone_number: phoneNumber,
    phone_number_country: phoneNumberCountry,
    ...(secondaryEmail && { support_email: secondaryEmail }),
  });
};

export const sendPreferencesData = async ({
  locale,
  timezone,
}: {
  locale: string;
  timezone: string;
}) => {
  return axiosApiInstance.patch(API_ENDPOINTS.AUTH.ONBOARDING.PREFERENCES, {
    locale,
    timezone,
  });
};

export const confirmOnboarding = async () => {
  return axiosApiInstance.patch(API_ENDPOINTS.AUTH.ONBOARDING.CONFIRMATION, {
    confirmation: 1,
  });
};
